import { getTextWidth } from '@thoughtspot/custom-style-service';
import { getNextBucketEpoch, getPrevBucketEpoch, timeBuckets, } from '@thoughtspot/date-format-util';
import { create } from '@thoughtspot/logger';
import { ignoreFillDateHoles } from './chart-type-formatter-util';
import { getXAxisLabelAt } from './formatter-service';
import { shouldOmitYear } from './formatter-util';
const logger = create('highchart-data-model');
function getEstimatedLabelWidth(axisId, omitYear, tickPositions, params, userOptions) {
    const userOptionsLabelStyles = userOptions.labels.style;
    const font = `${userOptionsLabelStyles.fontSize} ${userOptionsLabelStyles.fontFamily}`;
    const LABEL_PADDING = 15;
    const valueToRawValues = params.xValueToRawValues;
    const firstDate = valueToRawValues[0][0].value;
    const estimatedLongestlabel = getXAxisLabelAt(firstDate, params.allColumns, params.xAxisColumns, params.yAxisColumns, params.axes[axisId], params.chartType, valueToRawValues, tickPositions, { omitYear });
    return getTextWidth(estimatedLongestlabel, font) + LABEL_PADDING;
}
export function getDateTickPositioner() {
    const props = this.chart.userOptions.chart.props;
    if (props.xValueToRawValues.length === 0) {
        logger.warn('xValueToRawValues empty is not a valid scenario');
        return [];
    }
    const axisWidth = this.width;
    let newTickPositions = [];
    const xAxisColumn = props.allColumns[props.xAxisColumns[0]];
    const isColumnSortedDescendingly = xAxisColumn.isDescendingSort;
    const xValueToRawValues = props.xValueToRawValues;
    const firstxValueToRawValueObj = xValueToRawValues[0][0];
    const lastxValueToRawValueObj = xValueToRawValues[xValueToRawValues.length - 1][0];
    const firstDate = firstxValueToRawValueObj.value ?? firstxValueToRawValueObj.customValue;
    const lastDate = lastxValueToRawValueObj.value ?? lastxValueToRawValueObj.customValue;
    let minDate = isColumnSortedDescendingly ? lastDate : firstDate;
    let maxDate = isColumnSortedDescendingly ? firstDate : lastDate;
    const params = this.chart.userOptions.chart.props;
    const axisId = this.userOptions.id;
    const omitYear = shouldOmitYear(minDate, maxDate);
    const estimatedLabelWidth = getEstimatedLabelWidth(axisId, omitYear, this.tickPositions, params, this.userOptions);
    const ERROR_MARGIN = 0.1;
    const labelCount = Math.floor(((1 - ERROR_MARGIN) * axisWidth) / estimatedLabelWidth);
    const bucketization = xAxisColumn.timeBucket;
    let skipCoeff;
    if (bucketization === timeBuckets.NO_BUCKET ||
        ignoreFillDateHoles(minDate, maxDate, bucketization)) {
        let minDiff = Number.MAX_VALUE;
        xValueToRawValues.forEach((val, index) => {
            if (index > 0) {
                const currVal = val[0].value;
                const prevVal = xValueToRawValues[index - 1][0].value;
                const diff = Math.abs(currVal - prevVal);
                if (diff < minDiff) {
                    minDiff = diff;
                }
                minDate = currVal < minDate ? currVal : minDate;
                maxDate = currVal > maxDate ? currVal : maxDate;
            }
        });
        const potentialLabelCount = Math.ceil((maxDate - minDate) / minDiff);
        skipCoeff = Math.ceil(potentialLabelCount / labelCount);
        skipCoeff = skipCoeff === 0 ? 1 : skipCoeff;
        xValueToRawValues.forEach((val, index) => {
            if (index % skipCoeff === 0) {
                newTickPositions.push(val[0].value);
            }
        });
        const isSparse = newTickPositions.length <= labelCount / 2;
        if (isSparse) {
            const offset = Math.floor((maxDate - minDate) / (labelCount - 1));
            newTickPositions = [];
            let date = minDate;
            do {
                newTickPositions.push(date);
                date += offset;
            } while (date <= maxDate && offset > 0);
        }
    }
    else {
        const allXValues = [];
        if (isColumnSortedDescendingly) {
            let date = maxDate;
            while (date >= minDate) {
                allXValues.push(date);
                date = getPrevBucketEpoch(date, bucketization);
            }
        }
        else {
            let date = minDate;
            while (date <= maxDate) {
                allXValues.push(date);
                date = getNextBucketEpoch(date, bucketization);
            }
        }
        skipCoeff = Math.ceil(allXValues.length / labelCount);
        skipCoeff = skipCoeff === 0 ? 1 : skipCoeff;
        allXValues.forEach((value, index) => {
            if (index % skipCoeff === 0) {
                newTickPositions.push(value);
            }
        });
    }
    return newTickPositions;
}
//# sourceMappingURL=dateTickPositioner.js.map